import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type ScreenSizeBreakpoint = 'large' | 'small';

@Injectable({
  providedIn: 'root',
})
export class ScreenSizeDetectorService {
  private mq?: MediaQueryList;

  isSmallScreen = true;
  isLargeScreen = false;
  bpLayoutSwitchSize = '1024px';

  screenSize$ = new BehaviorSubject<ScreenSizeBreakpoint>('large');

  constructor() {
    if (window?.matchMedia) {
      this.bpLayoutSwitchSize = getComputedStyle(document.documentElement).getPropertyValue('--bp-layout-switch') ?? this.bpLayoutSwitchSize;

      this.mq = window.matchMedia(`(min-width: ${this.bpLayoutSwitchSize})`);

      this.update(this.mq.matches);

      this.mq.addEventListener('change', (event) => {
        this.update(event.matches);
      });
    }
  }

  private update(isLargeScreen: boolean): void {
    this.isLargeScreen = isLargeScreen;
    this.isSmallScreen = !this.isLargeScreen;

    const screenSize = (this.isLargeScreen ? 'large' : 'small') as ScreenSizeBreakpoint;

    document.body.dataset['screenType'] = screenSize;

    this.screenSize$.next(screenSize);
  }
}
